import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-brand-dark text-white overflow-hidden" data-id="element-99">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-100">
        <img src="https://cdn.magicpatterns.com/uploads/qrN4Afcysw5WuSXhZNg5GH/Used-0316_Profile_RW_007.jpg" alt="" aria-hidden="true" className="w-full h-full object-cover" data-id="element-101" />
        {/* Overlay for legibility — darker on the left, fading right */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/85 to-brand-dark/40" data-id="element-102" />
        <div className="absolute inset-0 bg-brand-dark/30 md:bg-transparent" data-id="element-103" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 py-20 md:py-28 lg:py-36 mt-[20px] mb-[20px] space-y-[15px] pt-[60px] pb-[60px]" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-105">
          <span className="uppercase tracking-widest font-bold text-brand-accent mb-4 block text-[11px]" data-id="element-106">
            Lancer Service · Toyota & Lexus Repair in St. Paul, MN
          </span>
          <h1 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-107">
            We know your Toyota.
          </h1>
          <div className="text-lg md:text-xl text-gray-200 mb-8 space-y-4" data-id="element-108">
            <p className="font-bold text-white" data-id="element-109">
              Toyotas are built to last. Getting there takes the right shop —
              one that knows how these vehicles age, what to watch for, and when
              to leave well enough alone.
            </p>
            <p data-id="element-110">
              ASE-certified technicians. Serving St. Paul since 1977. We've
              worked on more Camrys, Tacomas, RAV4s, Priuses, 4Runners, and
              Lexus vehicles than we can count — and we'll tell you honestly
              what your car needs and what it doesn't.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-5" data-id="element-111">
            <a href="https://www.lancerservice.com/" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20" data-id="element-112">
              Schedule Free Inspection
            </a>
            <a href="tel:6512240267" className="inline-flex justify-center items-center px-8 py-4 bg-brand-dark/50 backdrop-blur-sm border-2 border-gray-500 hover:border-gray-300 text-white font-bold rounded-md transition-colors" data-id="element-113">
              Call (651) 224-0267
            </a>
          </div>

          <div className="text-sm font-medium space-y-1.5" data-id="element-114">
            <p className="text-white" data-id="element-115">
              <span className="text-brand-accent tracking-wider" data-id="element-116">★★★★★</span>{' '}
              <span className="font-bold" data-id="element-117">4.9</span>{' '}
              <span className="text-gray-300 text-[11px]" data-id="element-118">
                · 595 Google Reviews · Trusted in St. Paul since 1977
              </span>
            </p>
            <p className="text-gray-300" data-id="element-119">
              Free estimates · Photos & video included
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}